import React from 'react'
import {
    TouchableOpacity,
    Dimensions
} from 'react-native'
import { useHeaderHeight } from '@react-navigation/stack'
import { Box, HStack, Icon, Text } from 'native-base'
import { AntDesign, MaterialCommunityIcons } from '@expo/vector-icons'
import { Agenda } from 'react-native-calendars'
import moment from 'moment'

export default function ReservationCalendar(props) {
    const headerHeight = useHeaderHeight();
    const { t, reservationItems, selectedMonth, startDate, endDate } = props


    const renderItem = (item) => {
        const { product, time, count, userCountMax } = item
        return (
            <TouchableOpacity onPress={() => props.onItemPress(product._id, time)}>
                <Box m={2} p={2} shadow={2}>
                    <Text fontSize={'xs'} p={1}>{product.name}</Text>
                    <Text fontSize={'xs'} p={1} color={'gray.200'}>{product.introduction}</Text>
                    <HStack>
                        <HStack px={2}>
                            <Icon name={'clock-outline'} as={MaterialCommunityIcons} size={'xs'} />
                            <Text fontSize={'xs'}>{moment(time).format('HH:mm')}</Text>
                        </HStack>
                        <HStack px={2}>
                            <Icon name={'user'} as={AntDesign} size={'xs'} />
                            <Text fontSize={'xs'}>{`${count}/${userCountMax}`}</Text>
                        </HStack>
                    </HStack>
                </Box>
            </TouchableOpacity>
        )
    }

    const renderEmptyDate = () => {
        return (
            <Box />
        )
    }

    const rowHasChanged = (r1, r2) => {
        return r1.name !== r2.name;
    }

    return (
        <Box h={Dimensions.get('window').height - headerHeight} bgColor={"white"} w='100%'>
            <Text fontSize={'sm'} fontWeight={'bold'} p={2} bg={'gray.100'}>{selectedMonth}</Text>
            <Agenda
                items={reservationItems}
                loadItemsForMonth={(date) => props.loadItems(date)}
                selected={moment().format('YYYY-MM-DD')}
                renderItem={(item) => renderItem(item)}
                renderEmptyDate={() => renderEmptyDate()}
                rowHasChanged={(r1, r2) => rowHasChanged(r1, r2)}
                // onRefresh={() => props.onRefresh()}
                refreshing={false}
                refreshControl={null}
                pastScrollRange={1}
                futureScrollRange={2}
                minDate={startDate}
                maxDate={endDate}
                onDayChange={(day) => props.onDayChange(day)}
                theme={{
                    'stylesheet.agenda.main': {
                        header: {
                            height: 0,
                            width: 0,
                        },
                        knobContainer: {
                            height: 0,
                            width: 0,
                        },
                        knob: {
                            height: 0,
                            width: 0,
                        },
                        weekdays: {
                            height: 0,
                            width: 0,
                        },
                        reservations: {
                            flex: 1,
                        }
                    }
                }}
            />
        </Box>
    )
}
